import { numberToPrettyString, plural } from '@cian/utils';
import * as React from 'react';
import { connect } from 'react-redux';

import { Container } from '../../components/Container';
// import { Link } from '../../components/Link';
import { Text } from '../../components/Text/';
// import { TextAndIcon } from '../../components/TextAndIcon';
import { OFFER_PLURAL_VARIANTS } from '../../constants/offers';
import { SIZE_16, SIZE_60 } from '../../constants/sizes';

import { IApplicationState } from '../../types/redux';
import { Link } from '../../components/Link';
import { TextAndIcon } from '../../components/TextAndIcon';

interface IOffersHeaderStoreProps {
  count: number;
  mapFullUrl: string;
}

type TOffersHeaderProps = IOffersHeaderStoreProps;

const OffersHeader: React.StatelessComponent<TOffersHeaderProps> = (props) => {
  const {
    count,
    mapFullUrl,
  } = props;

  return (
    <Container
      dataMark="OffersHeader"
      height={SIZE_60}
      borderColor="gray_1"
      borderBottomWidth={0}
      borderStyle="solid"
      padding={`0 ${SIZE_16}`}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      noPrint
    >
      <Text color="gray_4" lineHeight={20}>{numberToPrettyString(count)} {plural(count, OFFER_PLURAL_VARIANTS)}</Text>
      <Container
        display="inline-flex"
        tagName="noindex"
        noPrint
      >
        <Link url={mapFullUrl} target="blank">
          <TextAndIcon
            alignItems="baseline"
            iconType="place"
            iconSize={16}
            iconColor="gray_4"
            iconColorHovered="black"
            color="gray_4"
            colorHovered="black"
            fontWeight="bold"
            offset={4}
            reverse
          >
            На карте
          </TextAndIcon>
        </Link>
      </Container>
    </Container>
  );
};

function mapStateToProps({ offersData }: IApplicationState): IOffersHeaderStoreProps {
  return {
    count: offersData.total || 0,
    mapFullUrl: offersData.mapFullUrl,
  };
}

export const OffersHeaderContainer = connect(mapStateToProps)(OffersHeader);
